module.exports = __webpack_public_path__ + "static/img/twin-wateway-1.f6454bb5.png";